const showShippingDetails = (productId) => {
  const accordion = document.getElementById(`pdp-shipping-${productId}`)
  if (!accordion) return

  const trigger = accordion.querySelector('button')
  if (accordion.classList.contains('collapse')) trigger?.click()
  accordion.scrollIntoView({ block: 'start' })
  trigger?.focus({ preventScroll: true })
}

export default showShippingDetails
